import { CSS_CLASSES } from '../../configs';
import './styles.scss';
var navigation = function navigation(targetId) {
  var bodyElm = document.body;
  var navElm = document.querySelector(targetId);
  var NAV_SHOWING_CLASS = CSS_CLASSES.navIsShowing;
  var IS_OPEN_CLASS = CSS_CLASSES.isOpen;
  var toggleNav = function toggleNav() {
    bodyElm.classList.toggle(NAV_SHOWING_CLASS);
    navElm.classList.toggle(IS_OPEN_CLASS);
  };
  if (navElm) {
    navElm.addEventListener('click', toggleNav);
    bodyElm.addEventListener('keydown', function (event) {
      if (event.keyCode === 27) {
        bodyElm.classList.remove(NAV_SHOWING_CLASS);
        navElm.classList.remove(IS_OPEN_CLASS);
      }
    });
  }
};
export default navigation;